export enum PatchNotesEditorMode {
  EDIT = 'edit',
  VIEW = 'view',
}
